import React, { useState } from "react";

interface IProps {
  children: React.ReactNode;
  tooltipText: string;
}

const Tooltip: React.FC<IProps> = ({ children, tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
      {showTooltip && (
        <div
          className={`hidden lg:block absolute z-50 whitespace-nowrap px-2 py-1 text-[14px] text-[#F609FF] font-[600] bg-white rounded shadow-lg top-[-30px]`}
        >
          {tooltipText}
        </div>
      )}
      {children}
    </div>
  );
};

export default Tooltip;
